export default "__VITE_ASSET__DeTAjlS4__"